export const styles = {
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '8px',
    },
    '& .MuiDialogContent-root, .MuiDialogTitle-root, .MuiDialogActions-root': {
      padding: 0,
    },
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '10px',
    textAlign: 'center',

    '& > h2': {
      fontWeight: '700',
      fontSize: '28px',
      lineHeight: '34px',
      fontFamily: "'Proxima Nova', sans-serif",
    },
    '@media screen and (max-width: 768px)': {
      '& > h2': {
        fontWeight: '700',
        fontSize: '24px',
        lineHeight: '34px',
        fontFamily: "'Proxima Nova', sans-serif",
      },
    },
  },
  contentWrap: {
    padding: '0 32px 48px',
    width: '600px',
    '@media screen and (max-width: 768px)': {
      width: '100%',
    },
  },
  text: {
    fontWeight: 400,
    fontSize: '16px',
    color: '#011533',
    textAlign: 'center',
    fontFamily: "'Proxima Nova', sans-serif",
    lineHeight: '22px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'hidden',
  },
  buttonWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px',
    width: '100%',
    maxWidth: '470px',
    '@media screen and (max-width:768px)': {
      maxWidth: '90%',
      flexDirection: 'column-reverse',
      gap: 16,
    },
  },
  cancelButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '12px',
    border: '1px solid #00112B',
    color: '#00112B',
    backgroundColor: '#FFFFFF',
    padding: '8px 16px',
    minWidth: '208px',
    fontWeight: 700,
    '&:hover': {
      border: '1px solid #004360',
      color: '#FFFFFF',
      backgroundColor: '#004360',
    },
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: '16px',
    lineHeight: '20px',
  },
  actionButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '12px',
    border: '#004360',
    color: '#FFFFFF',
    padding: '8px 16px',
    backgroundColor: '#004360',
    minWidth: '208px',
    fontWeight: 700,
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: '16px',
    lineHeight: '20px',
    '&:hover': {
      border: '1px solid #004360',
      color: '#004360',
      backgroundColor: '#FFFFFF',
    },
  },
}
